import { render } from "./LogoText.vue?vue&type=template&id=1627dc4d&scoped=true"
import script from "./LogoText.vue?vue&type=script&lang=js"
export * from "./LogoText.vue?vue&type=script&lang=js"

import "./LogoText.vue?vue&type=style&index=0&id=1627dc4d&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1627dc4d"]])

export default __exports__